
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.292 22h-.582a.5.5 0 01-.5-.46l-.58-6.9a1.006 1.006 0 00-.28-.609l-.381-.4a1 1 0 00-.609-.29L4.45 12.8a.5.5 0 01-.45-.5v-.6a.5.5 0 01.45-.5l4.91-.54a1 1 0 00.609-.29l.381-.4c.16-.166.259-.38.28-.61l.58-6.9a.5.5 0 01.5-.46h.58a.5.5 0 01.5.46l.58 6.9c.021.23.12.444.28.61l.38.4a1 1 0 00.61.29l4.91.54a.5.5 0 01.45.5v.6a.5.5 0 01-.45.5l-4.91.54c-.23.024-.446.126-.61.29l-.38.4c-.16.165-.259.38-.28.609l-.58 6.9a.5.5 0 01-.498.461zm5.238-3.58a.509.509 0 01-.34-.13L15.66 17a.5.5 0 01-.041-.7l.64-.64a.499.499 0 01.74 0l1.281 1.54a.51.51 0 010 .68l-.41.41a.509.509 0 01-.34.13zm-11.08-.01a.512.512 0 01-.341-.13l-.409-.41a.508.508 0 010-.679L7 15.66a.5.5 0 01.7-.04l.64.64a.5.5 0 010 .741L6.79 18.28a.51.51 0 01-.34.13zm10.169-9.9a.5.5 0 01-.349-.144l-.64-.64a.499.499 0 010-.741L17.19 5.7a.51.51 0 01.679 0l.41.41a.51.51 0 010 .679L17 8.34a.5.5 0 01-.358.174l-.023-.004zM7.37 8.5A.5.5 0 017 8.34L5.72 6.79a.51.51 0 010-.679l.41-.41a.51.51 0 01.68 0L8.34 7a.5.5 0 01.04.7l-.64.64a.5.5 0 01-.37.16z","fill":"#fff"}})])
          )
        }
      }
    